module.exports = __webpack_public_path__ + "static/media/NEW-FONDOS_3.332321cc.svg";